import { render, staticRenderFns } from "./AppTabItem.vue?vue&type=template&id=3a9d2c1a&"
import script from "./AppTabItem.vue?vue&type=script&lang=js&"
export * from "./AppTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports